<template>
  <div class="">
    <div
      class="circle-loader"
      :class="{
        'load-complete': !isLoading,
        success: !isLoading && status == 'success',
        fail: !isLoading && status == 'fail',
        pending: !isLoading && status == 'pending',
      }"
    >
      <div
        ref="dynamicCheckmark"
        class="dynamic-checkmark"
        :class="{
          'circle-scale': !isLoading,
          success: !isLoading && status == 'success',
          fail: !isLoading && status == 'fail',
          pending: !isLoading && status == 'pending',
        }"
      >
        <div class="circle_red custom-shadow-inner" />
        <div class="circle_green custom-shadow-inner" />
        <div class="circle_gray custom-shadow-inner2">
          <div class="spinner-box">
            <div class="pulse-container flex">
              <div
                class="pulse-bubble pulse-bubble-1 flex-shrink-0 shadow-sm"
              />
              <div
                class="pulse-bubble pulse-bubble-2 flex-shrink-0 shadow-sm"
              />
              <div
                class="pulse-bubble pulse-bubble-3 flex-shrink-0 shadow-sm"
              />
            </div>
          </div>
        </div>
        <div class="mask_left" />
        <div class="mask_right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicCheckmark',
  props: {
    status: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isLoading: true,
      delay: 2000,
    };
  },
  watch: {
    status: {
      handler: function (newStatus, oldStatus) {
        console.log('dynamiccheckmark status changed');
        console.log('newStatus', newStatus);
        console.log('oldStatus', oldStatus);
        let self = this;
        if (newStatus) {
          // let checkmark = this.$refs['dynamicCheckmark'].$el.classList.toggle('draw');
          setTimeout(function () {
            self.isLoading = false;
            console.log('self.isLoading', self.isLoading);
          }, 50);
          setTimeout(function () {
            self.$refs.dynamicCheckmark.classList.toggle('draw');
          }, 550);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style>
/* Define CSS variables */
:root {
  --color-green-500: 84 199 116;
  --color-red-500: 219 55 19;
  --color-hover-gray: 216 220 237;
  --color-placeholder-gray: 199 203 219;
  --checkmark-success: rgb(var(--color-green-500));
  --checkmark-fail: rgb(var(--color-red-500));
  --checkmark-pending: rgb(var(--color-hover-gray));
  --checkmark-loading: rgb(var(--color-placeholder-gray));
  --loader-size: 2rem;
  --check-height: calc(var(--loader-size) / 2);
  --check-top: calc(var(--check-height) + var(--check-height) / 12);
  /* --check-top-fail1: calc(var(--check-height) * (0.375/2));
  --check-top-fail2: calc(var(--check-height) * (0.4375/2)); */
  --check-top-fail1: 0.95rem;
  --check-top-fail2: 1.078rem;
  --check-width: calc(var(--check-height) / 2);
  --check-left: calc(var(--loader-size) / 4);
  --check-left-fail: calc(var(--loader-size) / 5.27);
  --check-thickness: 3px;
  --check-color: var(--checkmark-success);
}

.circle-loader {
  /* margin-bottom: calc(var(--loader-size) / 2); */
  border: 4px solid rgb(var(--color-hover-gray));
  border-left-color: var(--checkmark-loading);
  animation: loader-spin 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: var(--loader-size);
  height: var(--loader-size);
}

.load-complete {
  animation: none;
  transition: border 500ms ease-out;
}

.load-complete.success {
  border-color: var(--check-color);
}

.load-complete.fail {
  border-color: var(--checkmark-fail);
}

.load-complete.pending {
  border-color: var(--checkmark-pending);
}

.dynamic-checkmark {
  border-radius: 100%;
  height: calc(100% + 8px);
  width: calc(100% + 8px);
  position: absolute;
  left: -4px;
  top: -4px;
  bottom: -4px;
  right: -4px;
}

.dynamic-checkmark.circle-scale .circle_green {
  background-color: var(--check-color);
  border-radius: 50%;
  height: 100%;
  width: 100%;
}

.dynamic-checkmark.circle-scale .circle_red {
  background-color: var(--checkmark-fail);
  border-radius: 50%;
  height: 100%;
  width: 100%;
}

.dynamic-checkmark.circle-scale .circle_gray {
  background-color: var(--checkmark-pending);
  border-radius: 50%;
  height: 100%;
  width: 100%;
}

.dynamic-checkmark.circle-scale div[class^='mask'] {
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
}

.dynamic-checkmark.circle-scale .mask_left {
  left: 0;
  right: 50%;
}

.dynamic-checkmark.circle-scale .mask_right {
  left: 50%;
  right: 0;
}

.dynamic-checkmark.circle-scale div[class^='mask']::before {
  background-color: #fff;
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}

/* .dynamic-checkmark.circle-scale .mask_left::before {
  animation: leftHalf 0.5s 0s 1 linear forwards;
  transform-origin: 100% 50%;
}

.dynamic-checkmark.circle-scale .mask_right::before {
  animation: rightHalf 0.5s 0s 1 linear forwards;
  transform-origin: 0% 50%;
} */

.dynamic-checkmark.circle-scale .mask_left::before {
  animation: leftHalf 0.5s 0s 1 linear forwards;
  transform-origin: 100% 50%; /* center right */
}

.dynamic-checkmark.circle-scale .mask_right::before {
  animation: rightHalf 0.5s 0s 1 linear forwards;
  transform-origin: 0% 50%; /* center left */
}

.dynamic-checkmark.circle-scale.success .circle_red,
.dynamic-checkmark.circle-scale.success .circle_gray {
  display: none;
}

.dynamic-checkmark.circle-scale.fail .circle_green,
.dynamic-checkmark.circle-scale.fail .circle_gray {
  display: none;
}

.dynamic-checkmark.circle-scale.pending .circle_green,
.dynamic-checkmark.circle-scale.pending .circle_red {
  display: none;
}

.dynamic-checkmark:not(.pending) .circle_gray {
  display: none;
}

.dynamic-checkmark.draw:after {
  animation-duration: 800ms;
  animation-timing-function: ease;
  animation-name: dynamic-checkmark;
  transform: scaleX(-1) rotate(135deg);
  animation-fill-mode: forwards;
}

.dynamic-checkmark.draw:before {
  animation-duration: 800ms;
  animation-timing-function: ease;
  animation-name: dynamic-checkmark;
  transform: scaleX(-1) scaleY(-1) rotate(135deg);
  animation-fill-mode: forwards;
}

.dynamic-checkmark.circle-scale.success:after {
  opacity: 0;
  height: var(--check-height);
  width: var(--check-width);
  transform-origin: left top;
  border-right: var(--check-thickness) solid #ffffff;
  border-top: var(--check-thickness) solid #ffffff;
  content: '';
  left: var(--check-left);
  top: var(--check-top);
  position: absolute;
}

.dynamic-checkmark.circle-scale.fail:before {
  opacity: 0;
  height: var(--check-height);
  width: var(--check-height);
  transform-origin: left top;
  border-right: var(--check-thickness) solid #ffffff;
  content: '';
  left: var(--check-left-fail);
  top: var(--check-top-fail1);
  position: absolute;
}

.dynamic-checkmark.circle-scale.fail:after {
  opacity: 0;
  height: var(--check-height);
  width: var(--check-height);
  transform-origin: left top;
  border-right: var(--check-thickness) solid #ffffff;
  content: '';
  left: var(--check-left-fail);
  top: var(--check-top-fail2);
  position: absolute;
}

@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dynamic-checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 0;
  }
  20% {
    height: 0;
    width: var(--check-width);
    opacity: 1;
  }
  40% {
    height: var(--check-height);
    width: var(--check-width);
    opacity: 1;
  }
  100% {
    height: var(--check-height);
    width: var(--check-width);
    opacity: 1;
  }
}

/* @keyframes leftHalf {
    0%, 50% { transform: rotate(0deg); }
    100% { transform: rotate(180deg); }
}

@keyframes rightHalf {
    0%, 100% { transform: rotate(0deg); }
    50% { transform: rotate(180deg); }
} */

/* @keyframes leftHalf {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(180deg); }
}

@keyframes rightHalf {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(180deg); }
    100% { transform: rotate(360deg); }
} */

@keyframes leftHalf {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
@keyframes rightHalf {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

.dynamic-checkmark {
  overflow: hidden !important;
}

.circle_gray .spinner-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.circle_gray .spinner-box .pulse-container {
  width: 68.2%;
  height: 67%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.circle_gray .spinner-box .pulse-container .pulse-bubble {
  width: 24%;
  height: 24%;
  border-radius: 50%;
  /* border: 0.25px solid #ffffff; */
  /* background: rgba(255, 255, 255, 1); */
  background: rgba(109, 113, 129, 1);
}

.circle_gray .spinner-box .pulse-container .pulse-bubble.pulse-bubble-1 {
  animation: pulse-bubble 1s linear 0s infinite alternate;
}
.circle_gray .spinner-box .pulse-container .pulse-bubble.pulse-bubble-2 {
  animation: pulse-bubble 1s linear 0.4s infinite alternate;
}
.circle_gray .spinner-box .pulse-container .pulse-bubble.pulse-bubble-3 {
  animation: pulse-bubble 1s linear 0.8s infinite alternate;
}

@keyframes pulse-bubble {
  0% {
    opacity: 1;
    /* background: rgba(255, 255, 255, 1); */
    background: rgba(109, 113, 129, 1);
    transform: scale(1);
    /* background: rgba(255, 255, 255, .45);
    transform: scale(.95); */
  }
  100% {
    /* opacity: .65; */
    /* background: rgba(255, 255, 255, .45); */
    background: rgba(109, 113, 129, 0.25);
    transform: scale(0.95);
    /* opacity: 1;
    background: rgba(255, 255, 255, 1);
    transform: scale(1); */
  }
}

.custom-shadow-inner {
  box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.12);
}
.custom-shadow-inner2 {
  box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.07);
}
</style>
